import { ChangeDetectorRef, Component } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { OrderService } from "src/app/frontoffice/order/order.service";
import { DepositFormSettingModel } from "../depositformsetting.model";
import { take, takeUntil } from "rxjs/operators";
import { ClearableCache } from "projects/sepidz-web-framework/src/lib/models/clearablecache.model";
import { LocalStoreManager, Utilities } from "projects/sepidz-web-framework/src/lib/services";
import { Observable } from "rxjs";

@Component({
  selector: "ngx-deposit-select-show-hide",
  templateUrl: "./deposit-select-show-hide.component.html",
  styleUrls: ["./deposit-select-show-hide.component.scss"],
})
export class DepositSelectShowHideComponent extends BaseFormComponent<DepositFormSettingModel> {
  service: OrderService;
  depositformsetting: DepositFormSettingModel;

  constructor(selectorService: SelectorService, cd: ChangeDetectorRef, public storage: LocalStoreManager) {
    super(selectorService, cd);
  }

  async ngOnInit() {
    this.apiName = "DepositFormSetting";
    this.label = this.translate("ClientApp.FrontOffice.Order.OrderPage.Item.Deposit.Settings");
    this.customColumnInfoApi = "DepositFormSetting/GetFormColumnInfo";
    this.changeNoCheck = true;
    super.ngOnInit();
    this.FillData();
  }

  FillData() {
    this.httpCommonService
      .getList("DepositFormSetting")
      .pipe(take(1))
      .subscribe((result: any[]) => {
        if (result?.length > 0) this.model = result[0];
        else {
          this.setValue("FoodPricePerson", true);
          this.setValue("HasClearType", true);
          this.setValue("HasDeliveryType", true);
          this.setValue("HasDepositAmount", true);
          this.setValue("HasNumberOfCooks", true);
          this.setValue("HasNumberOfPeople", true);
          this.setValue("HasServicesAmount", true);
        }
      });
    this.addControl();
  }
  addControl(): void {
    this.setValue("FoodPricePerson", this.model.FoodPricePerson ?? true);
    this.setValue("HasClearType", this.model.HasClearType ?? true);
    this.setValue("HasDeliveryType", this.model.HasDeliveryType ?? true);
    this.setValue("HasDepositAmount", this.model.HasDepositAmount ?? true);
    this.setValue("HasNumberOfCooks", this.model.HasNumberOfCooks ?? true);
    this.setValue("HasNumberOfPeople", this.model.HasNumberOfPeople ?? true);
    this.setValue("HasServicesAmount", this.model.HasServicesAmount ?? true);
    this.cd.markForCheck();
  }
  async saveForm() {
    if (this.model.Id === undefined || this.model.Id === 0 || Number.isNaN(this.model.Id) || this.model.Id === null) {
      this.httpCommonService
        .create(this.apiName, this.getDataFromFormGroup())
        .pipe(take(1))
        .subscribe(
          (response) => {
            this.saveSuccessHelper();
            this.model.Id = response;
            this.result = this.model;
            this.storage.savePermanentData(this.result, ClearableCache.FormSetting);
            this.service.controlsVisibility();
            this.closeModal();
            this.service.detectChanges();
          },
          (error) => {
            this.sts.showDialog(
              `${this.label}: ${Utilities.getHttpResponseMessage(error)}`,
              this.translate("ClientApp.FrontOffice.Order.OrderPage.Item.Deposit.ErrorSavingData")
            );
            this.result = this.model;
          }
        );
    } else {
      this.httpCommonService
        .update(this.apiName, this.getDataFromFormGroup())
        .pipe(take(1))
        .subscribe(
          (response) => {
            this.saveSuccessHelper();
            this.result = this.model;
            this.storage.savePermanentData(this.result, ClearableCache.FormSetting);
            this.service.controlsVisibility();
            this.closeModal();
            this.service.detectChanges();
          },
          (error) => {
            this.sts.showDialog(
              `${this.label}: ${Utilities.getHttpResponseMessage(error)}`,
              this.translate("ClientApp.FrontOffice.Order.OrderPage.Item.Deposit.ErrorSavingData")
            );
            this.result = this.model;
          }
        );
    }
    this.closeModal();
  }

  refreshSetting() {
    this.httpCommonService
      .getList("DepositFormSetting")
      .pipe(take(1))
      .subscribe((result: any[]) => {
        if (result?.length > 0) {
          this.storage.savePermanentData(result[0], ClearableCache.FormSetting);
        }
      });
  }

  override canDeactivate(): boolean | Observable<boolean> {
    this.closeForm(true);
    return true;
  }
}
